import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
    Grid, Card, InputLabel, MenuItem, Select, Button, Typography, Box
} from '@mui/material';
import SoftInput from "components/SoftInput";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import { CustomSelect } from 'admin/components/atoms';
import dummyLogo from '../../../assets/images/dummyImage.png'
import service from '../../api/services';
import { useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { CleaningServices } from '@mui/icons-material';
import { AutoComplete } from '../../components/atoms';
import SoftButton from 'components/SoftButton';
import { DATA_LIMIT } from 'utils/api';

const optionSchema = Yup.object({
    label: Yup.string().required('Label is required'),
    value: Yup.string().required('Value is required'),
}).required('required');

const validationSchema = Yup.object({
    amenityName: Yup.string().required('Amenity name is required'),
    logo: Yup.mixed().required('Logo is required'),
    category: Yup.array()
        .of(Yup.string().required('Category is required'))
        .min(1, 'At least one category is required')
        .required('Category is Required'),
});

const CreateAmenityForm = () => {
    const [preview, setPreview] = useState(null);
    const [categoryData, setCategoryData] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(false);
    const params = useParams()
    const navigate = useNavigate()
    const formik = useFormik({
        initialValues: {
            amenityName: '',
            logo: null,
            category: [],
        },
        validationSchema,
        onSubmit: async (values) => {
            try {
                // let tempID = values?.category?.map((item) => item.value)
                let tempID = values?.category
                const formData = new FormData();
                formData.append('name', values.amenityName);
                tempID?.forEach((cat) => {
                    formData.append('categories', (cat));
                });

                // for (i=0;i<tempID)
                if (values.logo) {
                    formData.append('logo', values.logo);
                }

                const response = params?.id
                    ? await service.amenities.edit(params?.id, formData)
                    : await service.amenities.add(formData);

                if (response.status === 200 || response.status === 201) {
                    navigate(-1);
                    
                    
                    toast.success(response?.data?.message);
                } else {
                    toast.error(response?.data?.message);
                }
            } catch (error) {
                toast.error(error?.response?.data?.message);
                console.error('Submission error:', error);
            }
        },
    });

    const handleFileChange = (event) => {
        const file = event.currentTarget.files[0];
        formik.setFieldValue('logo', file);
        if (file) {
            setPreview(URL.createObjectURL(file));
        }
    };





    const getAllCategory = async (value = '') => {
        try {
            setLoading(true)
            const response = await service.categories.view({ limit: DATA_LIMIT, searchData: value });
            if (response?.data?.data) {
                setCategoryData(
                    response.data.data.map((item) => ({
                        ...item,
                        label: item.name,
                        value: item._id,
                    }))
                );
                setLoading(false)
            }

        } catch (error) {
            console.error("Failed to fetch business users", error);
        }
    };

    const getDetailById = async () => {
        try {
            let res = await service.amenities.getDetailById(params.id)
            formik.setValues({
                amenityName: res.data.data.name || '',
                logo: res.data.data.logo || '',
                category: res?.data?.data?.categories
                // category: res?.data?.data?.categories?.map((item) => ({
                //     ...item,
                //     label: item.name,
                //     value: item._id,
                // })) || [],
            });
            setPreview(res.data.data.logo)
        } catch (error) {
            console.error("Failed to fetch keyword detail:", error);
        }
    };

    useEffect(() => {
        getAllCategory()
        if (params?.id) {
            getDetailById()
        }
    }, [])
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <SoftBox mt={3}>
                <Card className="glassmorphism-card"
                    sx={{
                        // width: 470,
                        minHeight: '500px',
                        display: "flex",
                        flexDirection: "column",
                        // justifyContent: "center",
                        // alignItems: "center",
                        padding: 2,
                        boxShadow: 2,

                    }}>
                    <SoftTypography variant="h6" color="text" fontWeight="bold" mb={2}>Create Amenity</SoftTypography>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <SoftTypography variant="caption" fontWeight="bold" required>Enter amenity<span style={{ color: 'red' }}>*</span></SoftTypography>
                                <SoftInput
                                    name="amenityName"
                                    placeholder="Enter amenity"
                                    value={formik.values.amenityName}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.amenityName && Boolean(formik.errors.amenityName)}
                                />
                                {formik.touched.amenityName && formik.errors.amenityName && (
                                    <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                        {formik.errors.amenityName}
                                    </SoftTypography>
                                )}
                            </Grid>

                            <Grid item xs={12}>
                                <SoftTypography variant="caption" fontWeight="bold" required>Upload logo<span style={{ color: 'red' }}>*</span></SoftTypography>
                                {<Box component="img" src={preview || dummyLogo} sx={{ height: 80, mb: 1 }} />}
                                <div>
                                    <input
                                        type="file"
                                        name="logo"
                                        accept="image/*"
                                        onChange={handleFileChange}
                                    />

                                </div>
                                {formik.touched.logo && formik.errors.logo && (
                                    <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                        {formik.errors.logo}
                                    </SoftTypography>
                                )}
                            </Grid>

                            <Grid item xs={12}>
                                <SoftTypography variant="caption" fontWeight="bold" required>Select Category<span style={{ color: 'red' }}>*</span></SoftTypography>
                                <AutoComplete
                                    fullWidth
                                    name="category"
                                    loading={loading}
                                    options={categoryData}
                                    placeholder= {"Search Category..."}
                                    onInputChange={(value) => {
                                        getAllCategory(value);  // trigger debounced API call
                                    }}
                                    value={categoryData.filter(option => formik.values.category.includes(option.value))}
                                    onChange={(e, value) => {
                                        const values = value.map(v => v.value); // only store values
                                        setInputValue('')
                                        formik.setFieldValue('category', values);
                                    }}
                                    onBlur={() => formik.setFieldTouched('category', true)}  // ✅ Set touched manually
                                    
                                    invalid={formik.touched.category &&Boolean(formik.errors.category)}
                                    error={formik.touched.category && Boolean(formik.errors.category)}
                                    multiple={true}
                                />

                                {formik.touched.category && formik.errors.category && (
                                    <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                        {formik.errors.category}
                                    </SoftTypography>
                                )}
                            </Grid>

                            <Grid item xs={12} display="flex" gap={2}>
                                <SoftButton type="submit" variant="gradient"
                                    color="info">Submit</SoftButton>
                                <SoftButton

                                    variant="outlined"
                                    color="info"
                                    onClick={() => navigate(-1)}
                                >
                                    Cancel
                                </SoftButton>
                            </Grid>
                        </Grid>
                    </form>
                </Card>
            </SoftBox>
        </DashboardLayout>
    );
};

export default CreateAmenityForm;
